import request from '@/modules/base/util/request'
import config from 'config'

const baseUrl = `${config.resourceHost}`

const SignatureService = {
  sign: (todoId, signatures) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}todo/${todoId}/sign/v2`, {
        auth: true,
        isConcurrent: true,
        method: 'POST',
        data: { signatures },
      })
        .then((response) => {
          const {
            body: { data },
          } = response
          resolve(data)
        })
        .catch(reject)
    })
  },
}

export default SignatureService

export { SignatureService }
